import React, { useState, useEffect } from 'react';

import Navbar from '../Navbar/Navbar';
import Home from '../Home/Home';
import Side from '../SidePos/Side';
import Modal from '../Modal/Modal';
import { MdSupportAgent } from "react-icons/md";
import { FaCarOn } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import Footer from '../Footer/Footer';

function Homepage() {
  const [showModal, setShowModal] = useState(false);
  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    mobile: ''
  });

  useEffect(() => {
    setShowModal(true);
  }, []);

  const hideModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formValues);
    hideModal();
  };

  return (
    <>
      <Modal show={showModal} handleClose={hideModal}>
      <div className='modal-full'>
      <div className='modalleft'>
      <h4 className='modal-heading'>We Promise</h4>
        <div className='modal-logo-left'>
        <MdSupportAgent className='modal-logo1'/>
          <p className='modal-sub-heading'>Instant Call Back </p>
        </div>
        <div className='modal-logo-left'>
        <FaCarOn className='modal-logo1'/>
          <p className='modal-sub-heading'>Free Site Visit</p>
        </div>
        <div className='modal-logo-left'>
        <GiReceiveMoney className='modal-logo1'/>
          <p className='modal-sub-heading'>Unmatched Price</p>
        </div>
      </div>
      <div className='modalright'>
        <h2 className="modal-heading">Ace Residential</h2>
        <p className='modal-sub-heading'>At Sector 12, Noida Extension</p>
        <form className="modal-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" name="name" value={formValues.name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" value={formValues.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="mobile">Mobile:</label>
            <input type="tel" id="mobile" name="mobile" value={formValues.mobile} onChange={handleChange} required />
          </div>
          <div className='butt-f'>
            <button className="submit-button-f" type="submit">Get Instant Call back</button>
          </div>
        </form>
        </div>
        </div>
      </Modal>
      <Navbar />
      <Side />
      <Home />
      <Footer/>
    </>
  );
}

export default Homepage;
